module.exports = __webpack_public_path__ + "img/print_outlined_32.54727819.svg";